import { api } from '../lib/api'

export interface SnapshotKpis {
  consolidado?: Record<string, number>
  porPlataforma?: Array<Record<string, string | number>>
  ga4?: Record<string, number> | null
}

export interface SeriesPoint {
  periodEnd: string // YYYY-MM-DD
  kpis: SnapshotKpis
}

export interface KpiSeries {
  cuts: string[]
  metrics: string[]
  platforms: string[]
  series: Record<string, SeriesPoint[]>
}

export interface TrendAnalysis {
  id: string
  clientId: string
  content: string
  periodLabel: string
  reportsCount: number
  model: string
  generatedAt: string
}

export const trendsApi = {
  series: (clientId: string) => api.get<KpiSeries>(`/trends/${clientId}/series`),
  analysis: (clientId: string) =>
    api.get<{ analysis: TrendAnalysis | null }>(`/trends/${clientId}/analysis`),
  analyze: (clientId: string) =>
    api.post<{ analysis: TrendAnalysis }>(`/trends/${clientId}/analyze`, {}),
}
